import { render, staticRenderFns } from "./TopImg.vue?vue&type=template&id=73b2f66c&scoped=true&"
import script from "./TopImg.vue?vue&type=script&lang=js&"
export * from "./TopImg.vue?vue&type=script&lang=js&"
import style0 from "./TopImg.vue?vue&type=style&index=0&id=73b2f66c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73b2f66c",
  null
  
)

export default component.exports